var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFeatrureListIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.093,
    height: 15.093,
    viewBox: "0 0 15.093 15.093",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icn_node",
    d: "M9.616,14.908a2.509,2.509,0,0,1-.8-.5,2.335,2.335,0,0,1-.536-.746,2.219,2.219,0,0,1,0-1.826,2.292,2.292,0,0,1,.109-.211L4.011,8.049a2.535,2.535,0,0,1-.535.29,2.663,2.663,0,0,1-1.947,0,2.509,2.509,0,0,1-.8-.5A2.338,2.338,0,0,1,.2,7.091a2.22,2.22,0,0,1,0-1.826,2.337,2.337,0,0,1,.536-.746,2.509,2.509,0,0,1,.8-.5,2.664,2.664,0,0,1,1.947,0,2.509,2.509,0,0,1,.8.5A2.386,2.386,0,0,1,4.6,4.9l5.52-2.2a2.224,2.224,0,0,1,.168-1.267,2.337,2.337,0,0,1,.536-.746,2.509,2.509,0,0,1,.8-.5,2.663,2.663,0,0,1,1.947,0,2.508,2.508,0,0,1,.8.5,2.338,2.338,0,0,1,.536.746,2.22,2.22,0,0,1,0,1.826A2.336,2.336,0,0,1,14.36,4a2.508,2.508,0,0,1-.8.5,2.627,2.627,0,0,1-.948.184l-1.1,5.873.051.02a2.509,2.509,0,0,1,.8.5,2.337,2.337,0,0,1,.536.746,2.22,2.22,0,0,1,0,1.826,2.335,2.335,0,0,1-.536.746,2.509,2.509,0,0,1-.8.5,2.664,2.664,0,0,1-1.947,0Zm-.611-2.162a1.588,1.588,0,1,0,1.584-1.486A1.539,1.539,0,0,0,9.006,12.746Zm.1-1.89a2.539,2.539,0,0,1,.509-.272,2.615,2.615,0,0,1,.826-.18l1.114-5.922A2.5,2.5,0,0,1,10.822,4a2.392,2.392,0,0,1-.312-.357L4.979,5.85a2.224,2.224,0,0,1-.173,1.241q-.043.094-.093.184ZM.917,6.178A1.539,1.539,0,0,0,2.5,7.663,1.539,1.539,0,0,0,4.086,6.178,1.539,1.539,0,0,0,2.5,4.692,1.539,1.539,0,0,0,.917,6.178ZM12.591,3.831a1.539,1.539,0,0,0,1.584-1.486,1.588,1.588,0,0,0-3.169,0,1.4,1.4,0,0,0,.022.25l.284.627A1.619,1.619,0,0,0,12.591,3.831Z",
    transform: "translate(0 0)",
    fill: "#3953fe",
    opacity: 0.5
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFeatrureListIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/featrureListIcon.53a5ae8a.svg";
export { ForwardRef as ReactComponent };